import { useSelector } from 'react-redux';
import { useMutation, UseMutationResult, useQuery, UseQueryResult } from '@taxdown/zeno-sama-query';
import RecordsService from 'Services/records';
import CheckoutService from 'Services/checkout';
import { history } from 'Store';
import { routeStateSelector } from 'Store/modules/router/selectors';
import { routes } from 'Constants/routes';
import { QueryKeys, ResponseType, ResultType } from 'Types/common';

export const redirectTo = (route: string, params?: object): void => {
  setTimeout(() => {
    history.push(route, params);
  }, 3000);
};

export const useFetchGetSuccessResult = ({
  isFiling,
  plans,
  compensation,
  fromFedUser,
  saveCard,
  isExtendedFlexLite,
  isExtendedAndIsToReturn,
}: {
  isFiling: boolean;
  plans?: string;
  compensation?: boolean;
  fromFedUser?: boolean;
  saveCard?: boolean;
  isExtendedFlexLite?: boolean;
  isExtendedAndIsToReturn?: boolean;
}): UseQueryResult<ResultType> => {
  const routeState = useSelector(routeStateSelector);
  return useQuery([QueryKeys.FETCH_SUCCESS_RESULT], RecordsService.getResultData, {
    select: ({ data }) => {
      const { item } = data;
      return item;
    },
    onSuccess: data => {
      if (fromFedUser) {
        redirectTo(routes.RESULT_EFIRMA, {
          taxReturnType: data?.taxReturnType,
          taxReturnResult: data?.taxReturnResult,
        });
      } else if (plans && !fromFedUser) {
        redirectTo(`${routes.FILING}?plans=${plans?.toString()}`, {
          taxReturnType: data?.taxReturnType,
          taxReturnResult: data?.taxReturnResult,
          compensation: routeState?.compensation || compensation,
          isExtendedFlexLite: isExtendedFlexLite || routeState?.isExtendedFlexLite,
          isExtendedAndIsToReturn: isExtendedAndIsToReturn || routeState?.isExtendedAndIsToReturn,
          alreadySavedCard: saveCard,
        });
      }
    },
    refetchOnWindowFocus: false,
    enabled: isFiling,
    refetchInterval: data => (data ? false : 500),
  });
};

export const useSubmitFlex = (): UseMutationResult<
  ResponseType<unknown>,
  { taxYear: string; type: string }
> => {
  return useMutation([QueryKeys.SUBSCRIBE_FLEX], CheckoutService.subscribeLiteFlex);
};
